module.exports = __webpack_public_path__ + "img/video.9380d10f.png";